
<script>
import { Pie } from 'vue-chartjs'


export default {
  extends: Pie,
  props: {
    chartdata: {
      type: Object,
      default: null
    },
    options: {
      type: Object,
      default: null
    }
  },

  data(){return {
    perchartdata:{}
  }},

  mounted () {
    //删除percentageprocess，将perchartdata替换为chartdata即可得到非百分比的值
    this.percentageprocess()
    this.renderChart(this.perchartdata, this.options)
  },

    methods:{
    //将其百分比化
    percentageprocess(){
    this.perchartdata=JSON.parse(JSON.stringify(this.chartdata))
     let percentagesets=[]
      this.perchartdata.datasets.forEach(obj=>{
        let sum=obj.data.reduce((a,b)=>a+b,0)
        obj.data.forEach((val,i)=>{
          obj.data[i]=Math.round(val/sum*100)/100
        })
        percentagesets.push(obj)
      }
      )
      
     this.perchartdata.datasets= percentagesets
      
    },
    render(){
      this.percentageprocess()
      this.renderChart(this.perchartdata, this.options)
    }
  }

}
</script>





// WEBPACK FOOTER //
// src/components/presentation/chart/charttype/pie.vue